const light = Object.freeze({
    primary: '#00975f',
    secondary: '#706f6f',
    navBackground: '#FFFFFF',
    tileBackground: '#FFFFFF',
    appBackground: '#F5F5F5',
    inputBackground: '#FFFFFF',
    logoColor: '#00975F',
    logoFontColor: '#FDFEFE',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FB8C00',
})

const dark = Object.freeze({
    primary: '#00975f',
    secondary: '#706f6f',
    navBackground: '#2C2C2C',
    tileBackground: '#2C2C2C',
    appBackground: '#1B1B1B',
    inputBackground: '#222222',
    logoColor: '#00975F',
    logoFontColor: '#FDFEFE',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FB8C00',
})

const props = Object.freeze({
    headerLogoWidth: 35,
    headerLogoSrc: require('@/assets/custom/images/headers/living-header.png')
})

module.exports = Object.freeze({
    light,
    dark,
    props
})

